import React from 'react'
import { makeStyles } from '@material-ui/core'

const HMapDisplayTabHeaderTabs = ({
  HMapTabs,
  currentTab,
  setCurrentTab
}) => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.top}>
        {HMapTabs.map((tab, idx) => (
          <div
            key={`${tab.title}_${idx}`}
            className={`${classes.tab} ${
              currentTab === tab.code && classes.activeTab
            }`}
            onClick={() => setCurrentTab(tab.code)}
          >
            {tab.title}
          </div>
        ))}
      </div>
    </>
  )
}

export default React.memo(HMapDisplayTabHeaderTabs)

const useStyles = makeStyles((theme) => ({
  header: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  top: {
    width: '100%',
    padding: '0 15px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.secondary.main}`,
    '&> div': {
      marginLeft: '5px'
    },
    '&> div:first-child': {
      marginLeft: '0px'
    }
  },
  tab: {
    width: '70px',
    height: '35px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '5px 5px 0 0',
    color: 'white',
    backgroundColor: '#9A9A9A',
    border: `2px solid #9A9A9A`,
    borderBottom: 'none',
    ...theme.typography.h3,
    cursor: 'pointer',
    transition: '0.3s ease-in-out'
  },
  activeTab: {
    backgroundColor: theme.palette.primary.accent,
    border: `2px solid ${theme.palette.primary.accent}`,
    borderBottom: 'none'
  }
}))
